import { useEffect, useRef, useState } from 'react';
import { clearSetting, saveFavoriteView, saveSetting } from '@icp/components';
import { useEventCallback } from '@icp/hooks';
import { loadGanttInitState } from './utils';

export default function useGanttSetting({
  defaultGanttState,
  settingKey,
  globalSettingKey,
  settingUrl,
}) {
  const [ganttState, setGanttState] = useState(defaultGanttState);
  const [favoriteView, setFavoriteView] = useState({ current: null, viewList: [] });
  const loading = useRef(true);

  useEffect(() => {
    loadGanttInitState(settingKey, globalSettingKey, settingUrl, defaultGanttState).then((res) => {
      loading.current = false;
      const { favoriteView: fv, ...other } = res;
      setGanttState(other);
      setFavoriteView(fv);
    });
  }, [defaultGanttState, globalSettingKey, settingKey, settingUrl]);

  const saveGanttState = useEventCallback((newState) => {
    return saveSetting(settingKey, newState);
  });

  const clearGanttState = useEventCallback(() => {
    clearSetting(settingKey);
  });

  const updateFavoriteView = useEventCallback((newFavoriteView) => {
    if (!settingKey) return;
    setFavoriteView(newFavoriteView);
    saveFavoriteView(settingKey, globalSettingKey, settingUrl, newFavoriteView, favoriteView);
  });

  return {
    loadingState: loading.current,
    // current state
    ganttState,
    setGanttState,
    saveGanttState,
    clearGanttState,
    // saved view list
    favoriteView,
    updateFavoriteView,
  };
}
